import { render, staticRenderFns } from "./child.vue?vue&type=template&id=679aa8f8&scoped=true&"
import script from "./child.vue?vue&type=script&lang=js&"
export * from "./child.vue?vue&type=script&lang=js&"
import style0 from "./child.vue?vue&type=style&index=0&id=679aa8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679aa8f8",
  null
  
)

export default component.exports